export const countriesWithCompanySearchEnabled = ['FR', 'NL']
